import { Link } from "react-router-dom";
import { allCategories } from "@/utils/subtitles";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-closed-captioning-line text-xl"></i>
            </span>
            <span className="font-heading text-base font-bold text-background-50">
              中文在线字幕
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-300">
            专注提供各类影视作品的高清中文字幕资源，支持在线预览与多格式下载，让每个人都能轻松看懂好内容。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">
            <Link to="/" className="hover:text-accent-300">
              快捷导航
            </Link>
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm text-background-300">
            <li>
              <Link to="/" className="transition-colors hover:text-accent-300">
                首页
              </Link>
            </li>
            <li>
              <Link to="/search" className="transition-colors hover:text-accent-300">
                字幕搜索
              </Link>
            </li>
            <li>
              <Link to="/about" className="transition-colors hover:text-accent-300">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/about" className="transition-colors hover:text-accent-300">
                用户反馈
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">
            <Link to="/category/movie" className="hover:text-accent-300">
              资源分类
            </Link>
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm text-background-300">
            {allCategories.map((cat) => (
              <li key={cat.slug}>
                <Link
                  to={`/category/${cat.slug}`}
                  className="transition-colors hover:text-accent-300"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">
            <Link to="/about" className="hover:text-accent-300">
              联系我们
            </Link>
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm text-background-300">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-base text-accent-400"></i>
              feedback@zimu-online.demo
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-base text-accent-400"></i>
              资源每日更新
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-community-line text-base text-accent-400"></i>
              字幕爱好者共建社区
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full flex-col gap-2 px-4 py-5 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 中文在线字幕免费高清 · 本站字幕资源仅供学习与交流，请支持正版影视作品。</p>
          <p className="text-background-400">
            站内下载与预览均为前端演示，实际文件下载需后端支持。
          </p>
        </div>
      </div>
    </footer>
  );
}